import { render, staticRenderFns } from "./PropostaRoot.vue?vue&type=template&id=508dade1&"
import script from "./PropostaRoot.vue?vue&type=script&lang=js&"
export * from "./PropostaRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports